import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import BlogList from '../Components/Blogs/BlogList'
import { db } from '../firebase.config';
import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';

const AllBolg = () => {
    const [blogs, setBlogs] = useState([])
    const fetchProperties = async () =>{
      const querySnapshot = await getDocs(collection(db, "blogs"));
      querySnapshot.forEach((doc) => {
       setBlogs((prev)=>[...prev,{
        id:doc.id,
        ...doc.data()
       }])
     
    
      });
    }
    const deleteBlog = async (id) =>{
       await deleteDoc(doc(db, "blogs", id))
      window.location.reload()
    
    }
    useEffect(() => {
     fetchProperties()
    }, [])
  return (
    <div>
        <MultiLevelSidebar />
        <BlogList blogs={blogs} deleteBlog={deleteBlog} />
    </div>
  )
}

export default AllBolg